import React, { Fragment } from 'react';
import { Routes, Route } from 'react-router-dom';
import RouteAuthentication from '../../../routeAuth';
import { SC_MODULES } from '@app/constants/sc.modules';
import NotAuthorizePage from '@modules/system/pages/NotAuthPage';
import { getAuth } from '@app/utils/auth.utils';
import NotFountPage from '@modules/system/pages/NotFoundPage';

const getRouteElement = (item) => {
    const ComponentToRender = item.main;
    if (item.isAuth) {
        return <ComponentToRender />;
    }
    if (item.functionId) {
        const isAuth = getAuth(SC_MODULES.ADMIN, item.functionId);
        const Comp = isAuth ? ComponentToRender : NotAuthorizePage;
        return <Comp />;
    }
    return <NotFountPage />;
};

const Body = () => {
    const routeList = RouteAuthentication.getRoutes();

    return (
        <Fragment>
            <Routes>
                {routeList.map((item, index) => (
                    <Route
                        key={index}
                        path={item.path}
                        element={getRouteElement(item)}
                    />
                ))}
            </Routes>
        </Fragment>
    );
};

export default Body;
